export const IndicesType = {
  PRICE_INDEX: {
    id: 1,
    nameEn: 'Price Index',
    nameAr: 'مؤشر الأسعار',
    icon: 'indices/price_index.png',
    comingSoon: false,
    sort: 1,
    slug: 'price-index',
  },

  VOLUME_INDEX: {
    id: 2,
    nameEn: 'Volume Index',
    nameAr: 'مؤشر الحجم',
    icon: 'indices/volume_index.png',
    comingSoon: false,
    sort: 2,
    slug: 'volume-index',
  },

  VOLATILITY_INDEX: {
    id: 3,
    nameEn: 'Volatility Index',
    nameAr: 'مؤشر التقلب',
    icon: 'indices/volatility_index.png',
    comingSoon: true,
    sort: 3,
    slug: 'volatility-index',
  },

  AFFORDABILITY_INDEX: {
    id: 4,
    nameEn: 'Affordability Index',
    nameAr: 'مؤشر القدرة على تحمل التكاليف',
    icon: 'indices/affordability_index.png',
    comingSoon: true,
    sort: 4,
    slug: 'affordability-index',
  },

  AUCTION_SUCCESS_RATE: {
    id: 5,
    nameEn: 'Auction Success Rate',
    nameAr: 'معدل نجاح المزاد',
    icon: 'indices/auction_success_index.png',
    comingSoon: true,
    sort: 5,
    slug: 'auction-success-rate',
  },

  PRICE_DISTRIBUTION: {
    id: 6,
    nameEn: 'Price Distribution',
    nameAr: 'توزيع الأسعار',
    icon: 'indices/price_distribution_index.png',
    comingSoon: true,
    sort: 6,
    slug: 'price-distribution',
  },
} as const;
